module.exports = __webpack_public_path__ + "c5530672c291a58054395e4700cf73be.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/squinty-23.png
// module id = 1672
// module chunks = 0